import { connect } from 'react-redux';
import HomePage from 'components/home/index';
import { getCountries } from 'redux-modules/country-profiles';
import { getHomeContent } from 'redux-modules/home';

import { parseMapCountries } from 'selectors/country-profiles';
import { parseHomeContent } from 'selectors/common';

const mapStateToProps = (state) => ({
  countries: parseMapCountries(state),
  home: parseHomeContent(state),
  mapsLoading: state.countryProfile.mapCountriesLoading
});

const mapDispatchToProps = (dispatch) => ({
  getCountries: () => dispatch(getCountries()),
  getHomeContent: () => dispatch(getHomeContent())
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./app/containers/home/index.js